import { Helmet } from "react-helmet-async";
import { SITE_URL } from "../../data/siteData";

const defaultTitle = "Quantum Spark Technology | Web, Mobile & AI Development Agency";
const defaultDescription =
  "Quantum Spark Technology builds custom websites, mobile apps, AI products, and blockchain solutions. Senior-led delivery with transparent scoping. Get a free quote today.";

export default function SEO({
  title = defaultTitle,
  description = defaultDescription,
  path = "/",
  image = `${SITE_URL}/Artboardcopy1.png`,
}) {
  const url = `${SITE_URL}${path}`;
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    name: "Quantum Spark Technology",
    url: SITE_URL,
    logo: `${SITE_URL}/Artboardcopy1.png`,
    description: defaultDescription,
    areaServed: "Worldwide",
    serviceType: [
      "Website Development",
      "Mobile App Development",
      "UI/UX Design",
      "Artificial Intelligence Development",
      "Blockchain Development",
      "Quality Assurance",
    ],
    sameAs: ["https://quantumsparktechnology.com"],
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Quantum Spark Technology" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
    </Helmet>
  );
}
